<template>
    <div class="flex flex-col items-center justify-center min-h-screen text-center px-4">
        <h1 class="text-6xl font-bold text-dark mb-4">404</h1>
        <h2 class="text-2xl font-semibold text-dark mb-2">Page non trouvée</h2>
        <p class="mb-6 text-gray-600">La page que vous recherchez n'existe pas ou a été déplacée.</p>

        <router-link to="/"
            class="bg-primary text-white rounded-lg px-6 py-3 transition-colors duration-100 hover:bg-primary-dark hover:text-white text-lg font-medium">
            Retourner à l'accueil
        </router-link>
    </div>
</template>

<script setup>
</script>

<style></style>